import apiBaseUrl from '../../utils/config.js';

class PointsBankAPI {
  constructor() {
    this.baseUrl = `${apiBaseUrl}/points-bank`;
  }

  getToken() {
    return localStorage.getItem('jwt');
  }

  getAuthHeaders() {
    const token = this.getToken();
    return {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    };
  }

  async #request(endpoint = '', method = 'GET', body = null) {
    const options = {
      method,
      headers: this.getAuthHeaders(),
    };

    if (body) {
      options.body = JSON.stringify(body);
    }

    try {
      const response = await fetch(`${this.baseUrl}${endpoint}`, options);
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || 'Request failed');
      }

      return response.headers.get('Content-Type')?.includes('application/json')
        ? await response.json()
        : await response.text();

    } catch (error) {
      console.error(`Error in ${method} ${endpoint}:`, error);
      throw error;
    }
  }

  // Get total points for a patient
  async getTotalPoints(patientId) {
    return this.#request(`/${patientId}`);
  }

  // Update total points for a patient
  async updateTotalPoints(patientId, totalPoints) {
    return this.#request(`/update/${patientId}?totalPoints=${totalPoints}`, 'PUT');
  }

  // Get all points entries
  async getAllPoints() {
    return this.#request('/all');
  }

  // Add new points entry
  async addPointsEntry(entry) {
    return this.#request('/add', 'POST', entry);
  }

  // Add points from appointment
  async addFromAppointment(patientId, pointsToAdd) {
    return this.#request(`/addFromAppointment?patientId=${patientId}&pointsToAdd=${pointsToAdd}`, 'POST');
  }

  async createMissingPointsBank(patientId) {
  const token = localStorage.getItem("jwt");

  const response = await fetch(`${this.baseUrl}/create-missing/${patientId}`, {
    method: "POST",
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });

  const text = await response.text();

  let data = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = { message: text };
  }

  if (!response.ok) {
    const msg =
      data?.error ||
      data?.message ||
      `Failed to create points bank. Status: ${response.status}`;
    throw new Error(msg);
  }

  return data || {};
}
}

export default PointsBankAPI;
